// extracted by mini-css-extract-plugin
export var AuthorSnippet = "style-module--AuthorSnippet--0fc2f";
export var Avatar = "style-module--Avatar--35c20";
export var Bio = "style-module--Bio--e23e3";
export var Description = "style-module--Description--0a6b8";
export var WrittenBy = "style-module--WrittenBy--a69f7";